const RaffleJackpot = ($) => {
	let jackpotEl = $("#js-raffle-jackpot__amount");
	if (!jackpotEl || jackpotEl.length <= 0 || !jackpotEl[0].dataset) return;
	let jackpotTotal = Number(jackpotEl[0].dataset.jackpot);

	function commaSeparateNumber(num) {
		let numString = num.toString();
		if (numString.length > 3) {
			let numStringArr = numString.split("").reverse();
			numStringArr.splice(3, 0, ",");
			numString = numStringArr.reverse().join("");
		}
		return `$${numString}`;
	}

	$({ tally: 0 }).animate(
		{ tally: jackpotTotal },
		{
			duration: 5000,
			// only swing and linear easing options available without plugins
			easing: "swing",
			step: function () {
				const newTally = Math.round(this.tally);
				jackpotEl.text(commaSeparateNumber(newTally));
			},
			complete: function () {
				jackpotEl.text(commaSeparateNumber(Math.round(this.tally)));
			},
		}
	);
};

export default RaffleJackpot;
